import { render, staticRenderFns } from "./BloodTypeChangeActivationType.vue?vue&type=template&id=fc717190&"
import script from "./BloodTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./BloodTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports